import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Supplier } from '../../../classes/supplier';
import { SupplierService } from '../../../services/supplier';
import { HttpErrorResponse } from '@angular/common/http';
import { emailListError, fiscalCodeError, joinEmails, normalizeEmails, normalizeFiscalCode, singleEmailError } from '../../../utils/supplierValidation';

@Component({
    selector: 'app-supplier-create-modal',
    templateUrl: './supplier-create-modal.component.html',
    styleUrls: ['./supplier-create-modal.component.css']
})
export class SupplierCreateModalComponent {
    supplier: Supplier = new Supplier();
    emails: string[] = [''];
    foreignSupplier: boolean = false;
    submitted: boolean = false;
    loadingCondition: boolean = false;

    constructor(public activeModal: NgbActiveModal,
                private supplierService: SupplierService) {
    }

    get cfError(): string | null {
        return this.submitted ? fiscalCodeError(this.supplier.CF, this.foreignSupplier) : null;
    }

    get emailFieldError(): string | null {
        return this.submitted ? emailListError(this.emails) : null;
    }

    trackByIndex(index: number): number {
        return index;
    }

    addEmail(): void {
        this.emails.push('');
    }

    removeEmail(index: number): void {
        if (this.emails.length > 1) {
            this.emails.splice(index, 1);
        }
    }

    onEmailChange(index: number, value: string): void {
        if ((value || '').includes(';')) {
            const parts = value.split(';').map(part => part.trim()).filter(part => part.length > 0);
            this.emails.splice(index, 1, ...(parts.length > 0 ? parts : ['']));
        }
    }

    hasEmailItemError(index: number): boolean {
        return this.submitted && singleEmailError(this.emails[index]) !== null;
    }

    createSupplier() {
        this.submitted = true;
        if (this.cfError || this.emailFieldError) {
            return;
        }
        this.supplier.CF = this.foreignSupplier
            ? this.supplier.CF.trim().replace(/\s+/g, ' ').toUpperCase()
            : normalizeFiscalCode(this.supplier.CF);
        this.supplier.Email = normalizeEmails(joinEmails(this.emails));
        this.loadingCondition = true;
        this.supplierService.create(this.supplier, this.foreignSupplier)
            .subscribe({
                next: (supplierCreated: Supplier) => {
                    this.loadingCondition = false;
                    this.activeModal.close(supplierCreated);
                },
                error: (err: HttpErrorResponse) => {
                    this.loadingCondition = false;
                    console.log(err);
                }
            });
    }

}
